
  import { Vue, Component, Prop } from 'vue-property-decorator';

  enum ModeEnum {
    SLIDE = 'slide',
    PUSH = 'push',
    ROTATE = 'rotate',
  }

  @Component
  export default class WordRotator extends Vue {
    visibleWordIndex: number = 0;

    @Prop({ default: '' }) readonly prepend!: string;
    @Prop({ default: '' }) readonly append!: string;
    @Prop({ default: '|' }) readonly separator!: string;
    @Prop([Array, String]) readonly words!: string | Array<string>;
    @Prop({ default: ModeEnum.ROTATE }) readonly mode!: ModeEnum;
    @Prop({ default: '' }) readonly customClass!: string;
    @Prop({ default: 2500 }) readonly animationDelay!: number;

    public $refs!: {
      rotator: HTMLElement;
      wordsWrapper: HTMLElement;
      words: HTMLElement[];
    };

    get wordArr(): Array<string> {
      if (WordRotator.isArrayOfStrings(this.words)) {
        return this.words as Array<string>;
      }

      if (typeof(this.words) === 'string') {
        return this.words.split(this.separator);
      }

      return [];
    }

    get nextWordIndex(): number {
      if (this.wordArrIndexList.indexOf(this.visibleWordIndex) === this.wordArrIndexList.length - 1) {
        /* If the item is the LAST item in the list */
        return 0;
      }

      return this.visibleWordIndex + 1;
    }

    get wordArrIndexList(): Array<number> {
      return Object.keys(this.wordArr).map(key => Number(key));
    }

    public mounted(): void {
      this.animateHeadline();
    }

    private static isArrayOfStrings(value: any, nonEmpty: boolean = false): boolean {
      return Array.isArray(value) &&
        (value.length > 0 || !nonEmpty) &&
        value.every(item => typeof item === 'string');
    }

    private animateHeadline(): void {
      const _this = this;
      let duration = this.animationDelay;

      setTimeout(function () {
        _this.hideWord(_this.visibleWordIndex >= 0 ? _this.visibleWordIndex : 0);
        _this.$refs.rotator.classList.remove('word-rotator-invisible');
      }, duration);
    }

    private hideWord(wordIndex: number) {
      const _this = this;
      this.switchWord(wordIndex, this.nextWordIndex);

      setTimeout(function () {
        _this.hideWord(_this.nextWordIndex);
      }, _this.animationDelay);
    }

    private switchWord(oldWordIndex: number, newWordIndex: number): void {
      const _this = this;
      const oldWord: HTMLElement = this.$refs.words[oldWordIndex];
      const newWord: HTMLElement = this.$refs.words[newWordIndex];
      let extraSpace = this.mode === ModeEnum.SLIDE ? 3 : 0;
      let delay = this.mode === ModeEnum.ROTATE ? (newWord.clientWidth > oldWord.clientWidth ? 0 : 600) : 0;
      this.visibleWordIndex = newWordIndex;

      setTimeout(function () {
        _this.rotatorWidthAnimationHandler(newWord.clientWidth + extraSpace);
      }, delay);
    }

    private rotatorWidthAnimationHandler(newWidth: number, duration: number = 400): void {
      let startTimestamp: number;
      const oldWidth = this.$refs.wordsWrapper.clientWidth;

      const step: FrameRequestCallback = (timestamp) => {
        if (!startTimestamp) {
          startTimestamp = timestamp;
        }
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);

        const currentWidth = progress > 0 ?
          progress * (newWidth - oldWidth) + oldWidth :
          oldWidth;
        this.$refs.wordsWrapper.style.width = `${currentWidth}px`;

        if (progress < 1) {
          window.requestAnimationFrame(step);
        }
      };

      window.requestAnimationFrame(step);
    }
  }
